import React from 'react';
import styled from 'styled-components';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';

import { CardTemplateCircleShape, CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { CardCircleShape, CardShapeDb } from '../redux/cardShapeDbSlice';

type ShapeSvgProps = {
  x: number;
  y: number;
  rotation: number;
  selecting?: boolean;
}
const ShapeSvg = styled.svg<ShapeSvgProps>`
  position: absolute;
  border: ${props => props.selecting ? '1px solid blue' : undefined};
  box-sizing: border-box;
  transform: ${props => 'translate(' + props.x + 'px, ' + props.y + 'px) rotate(' + props.rotation + 'deg) !important'};
  transform-origin: center;
`
type CircleEllipseProps = {
  strokeProps: {display: boolean, color: string, opacity: number, width: number};
  fillProps: {display: boolean, color: string, opacity: number};
}
const CircleEllipse = styled.ellipse<CircleEllipseProps>`
  stroke: ${props => props.strokeProps.color};
  stroke-opacity: ${props => props.strokeProps.display ? props.strokeProps.opacity : 0};
  stroke-width: ${props => props.strokeProps.width};
  fill: ${props => props.fillProps.color};
  fill-opacity: ${props => props.fillProps.display ? props.fillProps.opacity : 0};
`

type CircleShapeProps = {
  id?: string;
  item: CardTemplateCircleShape | CardCircleShape;
  setSelectingId?: (id: string | undefined) => void;
  dragItem?: (data: DraggableData, item: CardTemplateShapeDb | CardShapeDb, id: string) => void;
  scaleValue?: number;
  selecting?: boolean;
}
const CircleShape: React.FC<CircleShapeProps> = ({id, item, setSelectingId, dragItem, scaleValue, selecting}) => {
  const cx = selecting ? item.width / 2 - 1 : item.width / 2;
  const cy = selecting ? item.height / 2 - 1 : item.height / 2;
  const rx = item.stroke.display ? (item.width - item.stroke.width) / 2 : item.width / 2;
  const ry = item.stroke.display ? (item.height - item.stroke.width) / 2 : item.height / 2;

  return (
    <Draggable position={{x: item.x, y: item.y}}
      onStart={() => setSelectingId ? setSelectingId(id) : undefined}
      onDrag={(ev: DraggableEvent, data: DraggableData) => dragItem && id ? dragItem(data, item, id) : undefined}
      scale={scaleValue} disabled={!id}>
      <ShapeSvg width={item.width} height={item.height}
        x={item.x} y={item.y} rotation={item.rotation} selecting={selecting}
        xmlns="http://www.w3.org/2000/svg">
        <CircleEllipse cx={cx} cy={cy} rx={rx} ry={ry}
          strokeProps={item.stroke} fillProps={item.fill} />
      </ShapeSvg>
    </Draggable>
  );
}

export default CircleShape;
